import React from 'react'
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Container, Row } from 'react-bootstrap';
import "../product_vews/ProductVews.css"
import ReusableProductVews from '../organic1-reusable/ReusableProductVews'
const ProductVews = () => {
  return (
    <>
    <section id="product_vews">
    <Container>
    <h1>All Category Product</h1>
        <Tabs defaultActiveKey="featured" id="justify-tab-example" className="mb-3" justify>
          <Tab eventKey="featured" title="Most View Products">
            <Row style={{ rowGap: '20px' }}>
              <ReusableProductVews img="imeges/desktop1/mango.png"/>
              <ReusableProductVews img="imeges/desktop1/coriander leaves-small.png"/>
             <ReusableProductVews img="imeges/desktop1/strowbarry-small.png"/>
             <ReusableProductVews img="imeges/desktop1/broccoli-small.png"/>
             <ReusableProductVews img="imeges/desktop1/avocado-small.png"/>
             <ReusableProductVews img="imeges/desktop1/raw haldi-small.png"/>
             <ReusableProductVews img="imeges/desktop1/onian-small.png"/>
              <ReusableProductVews img="imeges/desktop1/tamoto-small.png"/>
            </Row>
          <div className="row" >
           
           </div>
          </Tab>
          <Tab eventKey="latest" title="Bestseller Product">
            <Row style={{ rowGap: '20px' }}>
              <ReusableProductVews img="imeges/desktop1/mango.png"/>
              <ReusableProductVews img="imeges/desktop1/coriander leaves-small.png"/>
             <ReusableProductVews img="imeges/desktop1/strowbarry-small.png"/>
             <ReusableProductVews img="imeges/desktop1/broccoli-small.png"/>
             <ReusableProductVews img="imeges/desktop1/avocado-small.png"/>
             <ReusableProductVews img="imeges/desktop1/raw haldi-small.png"/>
             <ReusableProductVews img="imeges/desktop1/onian-small.png"/>
              <ReusableProductVews img="imeges/desktop1/tamoto-small.png"/>
            </Row>
          </Tab>
          <Tab eventKey="best-seller" title="Top ratting Product">
            <Row style={{ rowGap: '20px' }}>
              <ReusableProductVews img="imeges/desktop1/mango.png"/>
              <ReusableProductVews img="imeges/desktop1/coriander leaves-small.png"/>
             <ReusableProductVews img="imeges/desktop1/strowbarry-small.png"/>
             <ReusableProductVews img="imeges/desktop1/broccoli-small.png"/>
             <ReusableProductVews img="imeges/desktop1/avocado-small.png"/>
             <ReusableProductVews img="imeges/desktop1/raw haldi-small.png"/>
             <ReusableProductVews img="imeges/desktop1/onian-small.png"/>
              <ReusableProductVews img="imeges/desktop1/tamoto-small.png"/>
            </Row>
          </Tab>
          
        </Tabs>
      </Container>
   </section>
        
    </>
  )
}

export default ProductVews

